import BrandIcon from '../assets/Icons/BrandIcon'
import PlansIcon from '../assets/Icons/PlansIcon'
import IdIcon from '../assets/Icons/IdIcon'
import BillIcon from '../assets/Icons/BillIcon'

export const signUpStepIcons = [
  {
    icon: BrandIcon,
    label: 'empresa'
  },
  {
    icon: IdIcon,
    label: 'dados pessoais'
  },
  {
    icon: PlansIcon,
    label: 'planos'
  },
  {
    icon: BillIcon,
    label: 'pagamento'
  }
]
